import { FilterData } from '../../../containers/quality_of_hire/HiringManagerEmployeeEvalPage';
import { ApiService } from '../../ApiService';

export class FilterService {
  public static get(): Promise<FilterData> {
    return ApiService.get<FilterData>('/api/quality_of_hire/filters', {});
  }
}
